import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type mobileState = {
    isMobile : boolean
}

const initState : mobileState = {
    isMobile : false
}

const mobileSlice = createSlice({
    name : 'mobileSlice' , 
    initialState : initState , 
    reducers : {
        setMobile : (state , action : PayloadAction<boolean>)=>{
            state.isMobile = action.payload ; 
        }
    }    
})

export const { setMobile } = mobileSlice.actions ; 
export default mobileSlice.reducer ; 